import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PageNotFond from "../pages/404";


export default function ProductDetail() {
  // Estado para el modal de imagen
  const [showModal, setShowModal] = useState(false);
  const { sku } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const backendUrl = "https://s902oia0ti.execute-api.us-east-1.amazonaws.com";
  const productDataURL = `${backendUrl}/perfume/${sku}`;
  
  let imageRepository = "https://s3.us-east-1.amazonaws.com/esencianomada.com.ar";  

  // Agrega un style responsivo para el contenedor de imagen y descripción
  const mediaContainerStyle = {
    display: "flex",
    flexDirection: "column", // por defecto columna (mobile)
    alignItems: "flex-start",
    gap: 16,
  };

  // Media query para desktop: imagen al lado de la descripción
  // Usamos un hook para detectar ancho de pantalla
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Aplica row-reverse solo si es desktop y el producto es "sevilla"
  let effectiveMediaContainerStyle = { ...mediaContainerStyle };
  if (isDesktop && product && product.name && product.name.toLowerCase().includes("sevilla")) {
    effectiveMediaContainerStyle.flexDirection = "row-reverse";
    effectiveMediaContainerStyle.alignItems = "flex-start";
  } else if (isDesktop) {
    effectiveMediaContainerStyle.flexDirection = "row";
    effectiveMediaContainerStyle.alignItems = "flex-start";
  }

  useEffect(() => {
    fetch(productDataURL)
      .then(async (res) => {
        // Si la respuesta no es JSON, lanza error
        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Respuesta no es JSON");
        }
        return res.json();
      })
      .then((data) => {
        if (!data || !data.name) {
          setProduct(null);
        } else {
          setProduct(data);
        }
      })
      .catch((err) => {
        console.error("Error al obtener el producto:", err);
        setProduct(null);
      })
      .finally(() => setLoading(false));
  }, [productDataURL]);

  useEffect(() => {
    if (product) {
      // Actualiza el título
      document.title = `${product.name} | Aromas Datasheet`;

      // URL de la imagen grande
      const product_image_large_url = product && product.images && product.images['large']
        ? `${imageRepository}/${product.images['large']}`
        : `${imageRepository}${product.image}`;

      // PRELOAD: Agrega o actualiza el preload de la imagen LCP
      let preloadImg = document.querySelector('link[rel="preload"][as="image"]');
      if (!preloadImg) {
        preloadImg = document.createElement('link');
        preloadImg.rel = 'preload';
        preloadImg.as = 'image';
        document.head.appendChild(preloadImg);
      }
      preloadImg.href = product_image_large_url;

      // Actualiza la meta descripción
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = "description";
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = product.description || "Ficha técnica de perfume";

      // Actualiza la imagen para Open Graph y Twitter
      const ogImage = document.querySelector('meta[property="og:image"]') || (() => {
        const m = document.createElement('meta');
        m.setAttribute('property', 'og:image');
        document.head.appendChild(m);
        return m;
      })();
      ogImage.setAttribute('content', product_image_large_url);

      const twitterImage = document.querySelector('meta[name="twitter:image"]') || (() => {
        const m = document.createElement('meta');
        m.setAttribute('name', 'twitter:image');
        document.head.appendChild(m);
        return m;
      })();
      twitterImage.setAttribute('content', product_image_large_url);

      // Actualiza el título para Open Graph y Twitter
      const ogTitle = document.querySelector('meta[property="og:title"]') || (() => {
        const m = document.createElement('meta');
        m.setAttribute('property', 'og:title');
        document.head.appendChild(m);
        return m;
      })();
      ogTitle.setAttribute('content', product.name + " | Aromas Datasheet");

      const twitterTitle = document.querySelector('meta[name="twitter:title"]') || (() => {
        const m = document.createElement('meta');
        m.setAttribute('name', 'twitter:title');
        document.head.appendChild(m);
        return m;
      })();
      twitterTitle.setAttribute('content', product.name + " | Aromas Datasheet");

      // Actualiza la descripción para Open Graph y Twitter
      const ogDesc = document.querySelector('meta[property="og:description"]') || (() => {
        const m = document.createElement('meta');
        m.setAttribute('property', 'og:description');
        document.head.appendChild(m);
        return m;
      })();
      ogDesc.setAttribute('content', product.description || "Ficha técnica de perfume");

      const twitterDesc = document.querySelector('meta[name="twitter:description"]') || (() => {
        const m = document.createElement('meta');
        m.setAttribute('name', 'twitter:description');
        document.head.appendChild(m);
        return m;
      })();
      twitterDesc.setAttribute('content', product.description || "Ficha técnica de perfume");
    }
  }, [product, imageRepository]);

  if (loading) return <div>Cargando...</div>;
  if (!product) return <PageNotFond />;

  // Define product_image_large_url aquí para que esté disponible en el render
  const product_image_large_url =
    product && product.images && product.images['large']
      ? `${imageRepository}/${product.images['large']}`
      : `${imageRepository}${product.image}`;

  // URL de la imagen original para el modal
  const product_image_original_url =
    product && product.images && product.images['original']
      ? `${imageRepository}/${product.images['original']}`
      : product_image_large_url;

  return (
    <div>
      <h1 className="text-3xl font-bold text-center text-gray-900 tracking-wide mb-8 uppercase">
        {product.name}
      </h1>
      <div className="flex flex-col md:flex-row md:items-start gap-8 md:flex-row-reverse product-detail-media">
        <div className="flex justify-center md:block">
          <img
            src={product_image_large_url}
            alt={product.name}
            className="max-w-xs md:max-w-md lg:max-w-md cursor-zoom-in"
            onClick={() => setShowModal(true)}
            title="Ver imagen en grande"
          />
        </div>

      {/* Modal de imagen grande */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80"
          onClick={() => setShowModal(false)}
          style={{ cursor: 'zoom-out' }}
        >
          <img
            src={product_image_original_url}
            alt={product.name}
            className="max-h-[90vh] max-w-[90vw]"
            style={{ background: '#fff' }}
            onClick={e => e.stopPropagation()}
          />
          <button
            onClick={() => setShowModal(false)}
            className="absolute top-4 right-4 text-white text-3xl font-bold bg-black bg-opacity-40 rounded-full px-3 py-1 hover:bg-opacity-70 focus:outline-none"
            aria-label="Cerrar imagen"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex-1 flex flex-col gap-4">
          <p className="m-0 w-full text-gray-700 text-base md:text-lg leading-relaxed">
            {product.description}
          </p>
          {product.tags && product.tags.length > 0 && (
            <div className="flex gap-2 flex-wrap mt-2">
              {product.tags.map((tag) => (
                <span
                  key={tag}
                  className="bg-blue-100 text-blue-700 rounded-full px-3 py-1 text-xs font-semibold"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {product.product_link && (
        <div className="my-6">
          <a
            href={product.product_link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-700 underline font-medium text-lg hover:text-blue-900 transition-colors"
          >
            Ver ficha técnica del producto
          </a>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <div className="flex gap-2 text-gray-600">
          <span className="font-semibold">Marca:</span>
          <span>{product.brand}</span>
        </div>
        <div className="flex gap-2 text-gray-600">
          <span className="font-semibold">Familia olfativa:</span>
          <span>{product.olfactory_family}</span>
        </div>
        <div className="flex gap-2 text-gray-600">
          <span className="font-semibold">Concentración:</span>
          <span>{product.concentration}</span>
        </div>
        <div className="flex gap-2 text-gray-600">
          <span className="font-semibold">Género:</span>
          <span>{product.gender}</span>
        </div>
        <div className="flex gap-2 text-gray-600">
          <span className="font-semibold">Tipo de envase:</span>
          <span>{product.bottle_type}</span>
        </div>
        <div className="flex gap-2 text-gray-600">
          <span className="font-semibold">Duración:</span>
          <span>{product.duration}</span>
        </div>
        <div className="flex gap-2 text-gray-600">
          <span className="font-semibold">Proyección:</span>
          <span>{product.projection}</span>
        </div>
        <div className="flex gap-2 text-gray-600">
          <span className="font-semibold">Tamaños:</span>
          <span>
            {(() => {
              // Si es array, procesar cada elemento
              if (Array.isArray(product.sizes)) {
                return product.sizes
                  .map((s) =>
                    typeof s === "string"
                      ? s
                      : typeof s === "object" && s !== null
                        ? Object.values(s)
                            .filter((v) => typeof v === "string")
                            .join(" / ")
                        : ""
                  )
                  .filter((v) => !!v && v.toLowerCase() !== "[object object]")
                  .join(", ") || "-";
              }
              // Si es string simple
              if (typeof product.sizes === "string") {
                return product.sizes;
              }
              // Si es objeto, procesar sus valores
              if (
                typeof product.sizes === "object" &&
                product.sizes !== null
              ) {
                return Object.values(product.sizes)
                  .map((v) =>
                    typeof v === "string"
                      ? v
                      : typeof v === "object" && v !== null
                        ? Object.values(v)
                            .filter((vv) => typeof vv === "string")
                            .join(" / ")
                        : ""
                  )
                  .filter((v) => !!v && v.toLowerCase() !== "[object object]")
                  .join(", ") || "-";
              }
              // Si no hay nada válido
              return "-";
            })()}
          </span>
        </div>

        {/* Notas del perfume (Salida, Corazón, Fondo) */}
        {product.notes && typeof product.notes === 'object' && (
          <div className="gap-2 md:col-span-full">
            <h2 className="font-semibold mb-2 text-gray-600">Notas:</h2>
            <ul className="gap-3 flex flex-col list-none">
              {/* Notas de Salida */}
              {Array.isArray(product.notes.head) && product.notes.head.length > 0 && (
                <li className="flex">
                  <span className="text-sm font-semibold text-gray-700 mx-2">Salida: </span>
                  <ul className="flex flex-wrap gap-2">
                    {product.notes.head.map((note, idx) => (
                      <li key={"head-"+idx} className="bg-gray-100 text-gray-800 rounded-full px-3 py-1 text-xs font-medium">
                        {note}
                      </li>
                    ))}
                  </ul>
                </li>
              )}
              {/* Notas de Corazón */}
              {Array.isArray(product.notes.heart) && product.notes.heart.length > 0 && (
                <li className="flex">
                  <span className="text-sm font-semibold text-gray-700 mx-2">Corazón: </span>
                  <ul className="flex flex-wrap gap-2">
                    {product.notes.heart.map((note, idx) => (
                      <li key={"heart-"+idx} className="bg-gray-100 text-gray-800 rounded-full px-3 py-1 text-xs font-medium">
                        {note}
                      </li>
                    ))}
                  </ul>
                </li>
              )}
              {/* Notas de Fondo */}
              {Array.isArray(product.notes.base) && product.notes.base.length > 0 && (
                <li className="flex">
                  <span className="text-sm font-semibold text-gray-700 mx-2">Fondo: </span>
                  <ul className="flex flex-wrap gap-2">
                    {product.notes.base.map((note, idx) => (
                      <li key={"base-"+idx} className="bg-gray-100 text-gray-800 rounded-full px-3 py-1 text-xs font-medium">
                        {note}
                      </li>
                    ))}
                  </ul>
                </li>
              )}
            </ul>
          </div>
        )}

      </div>



      <div className="product-detail-date mt-4 text-xs text-right italic text-gray-500">
        Última actualización: {new Date(product.last_update).toLocaleDateString()}
      </div>
    </div>
  );
}